import { render, staticRenderFns } from "./UnscheduledList.vue?vue&type=template&id=f7588fae&scoped=true"
import script from "./UnscheduledList.vue?vue&type=script&lang=js"
export * from "./UnscheduledList.vue?vue&type=script&lang=js"
import style0 from "../Followups/list-page.scss?vue&type=style&index=0&id=f7588fae&prod&lang=scss&scoped=true&external"
import style1 from "./UnscheduledList.scss?vue&type=style&index=1&id=f7588fae&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7588fae",
  null
  
)

export default component.exports